import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  activeMenuItem: 'Calls',
  onlineStatus: true,
  phoneNumber: { selectedCountry: {}, number: '', isLoading: false },
  contactNumber: { selectedCountry: {}, number: '', isLoading: false },
  thread: {
    number: '',
    name: '',
    isThreadOpen: false,
    redirectTo: '',
    isThreadLoading: false,
  },
};
export const sliceKey = 'activeDialerView';

export const activeDialerViewSlice = createSlice({
  name: sliceKey,
  initialState,
  reducers: {
    activeMenu: (state, { payload }) => {
      try {
        state.activeMenuItem = payload.activeMenuItem;
      } catch (e) {
        console.log(e);
      }
    },
    availabilityStatus: (state, { payload }) => {
      try {
        state.onlineStatus = payload.onlineStatus;
      } catch (e) {
        console.log(e);
      }
    },
    activeDialerViewDialed: (state, { payload }) => {
      try {
        state.phoneNumber = payload;
      } catch (e) {
        console.log(e);
      }
    },
    activeContactViewDialed: (state, { payload }) => {
      try {
        state.contactNumber = payload;
      } catch (e) {
        console.log(e);
      }
    },

    setThread: (state, { payload }) => {
      try {
        state.thread.number = payload?.number;
        state.thread.name = payload?.name;
        state.thread.isThreadOpen = payload?.isThreadOpen;
        state.thread.redirectTo = payload?.redirectTo;
        state.thread.isThreadLoading = payload.isThreadLoading;
      } catch (e) {
        console.log(e);
      }
    },
  },
});

export const {
  activeMenu,
  activeDialerViewDialed,
  activeContactViewDialed,

  availabilityStatus,
  setThread,
} = activeDialerViewSlice.actions;

export default activeDialerViewSlice.reducer;
